import React, { useEffect,useState } from 'react'


import AddIcon from '@material-ui/icons/Add'
//import Button from '@material-ui/core/Button'
import { Button,Toaster, Position,Intent } from "@blueprintjs/core";
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import '../mytoaster.css';

const initialUser = {
  nom_enseignant: '',
  email_enseignant: '',
  age: 0,
  matiere:'',
  visits: 0,
  status: 'Hors ligne',
  progress: 0,
  subRows: undefined,
}

const AddUserDialog = props => {
  const [user, setUser] = useState(initialUser)
  const { userid,addUserHandler } = props
  const [open, setOpen] = React.useState(false)
  const [isValidCode, setisValidCode] = React.useState(false)

  useEffect(() => {
    console.log("mounted");
    setisValidCode(false);
  }, []);
  

  const [switchState, setSwitchState] = React.useState({
    addMultiple: false,
  })
 
  const handleSwitchChange = name => event => {
    setSwitchState({ ...switchState, [name]: event.target.checked })
  }

  const resetSwitch = () => {
    setSwitchState({ addMultiple: false })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setUser(initialUser)
    setisValidCode(false);
    resetSwitch()
  }

  const handleAdd = event => {
    handleSendCode(user.firstName)
    
    
  }

  const handleChange = name => ({ target: { value } }) => {
    console.log(name)
    console.log(value)
    setisValidCode(false);
    if(value.length==6) setisValidCode(true);
    setUser({ ...user, [name]: value })
  }
  const handleSendCode=function(code)
{
  //toaster.show( {message:"login utilisateur: "+ userinfo.username+" - "+userpassword.password});
  const toaster=Toaster.create({
    className: "my-toaster",
    position: Position.TOP_RIGHT,
  });
  setisValidCode(false);
  var xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
      //  var formData = new FormData();
        //formData.append('code', code);
      
        xhr.open('GET','/api/public/setmatieresbycode?code='+code+"&id="+userid)
       
        xhr.setRequestHeader("Content-Type", "application/json");

        //send the form data
        xhr.send();//JSON.stringify(Object.fromEntries(formData)));

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                          
             if(xhr.status==200) 
             { 
              //setisValidCode(true);
              console.log(xhr.responseText);
               var jsonResponse = JSON.parse(xhr.responseText);
               console.log(jsonResponse);
               if(jsonResponse.name=="")
               {
                toaster.show( {icon:"person", intent:Intent.DANGER,timeout:2000,message:"Le code ne correspond pas à un enseignant"});setisValidCode(true); 
                return;
               }
               //setUserToken({token:jsonResponse.token})
              // setUsernickname({nickname:jsonResponse.nickname})
               toaster.show( {icon:"person", intent:Intent.SUCCESS,message:"Enseignant(e) et sa matière "+ jsonResponse.matiere + " ajouté(e)s "});
               let userl=user;
               userl.nom_enseignant=jsonResponse.name;
               userl.matiere=jsonResponse.matiere;
               userl.email_enseignant=jsonResponse.email;
               

               setUser(user => ({...user,user:userl}))
               
               console.log("flag")
               console.log(user)
               addUserHandler(user)
               setUser(initialUser)
               switchState.addMultiple ? setOpen(true) : setOpen(false)
               //setisValidCode(false);
              // setIsConnected('none')
              // setNavFilesVisible('flex');
              // setIsConnected('none');
              // localStorage.setItem("nickname",jsonResponse.nickname);// JSON.stringify(name));
             }
             if(xhr.status==404) {toaster.show( {icon:"person", intent:Intent.DANGER,timeout:2000,message:"CODE INCONNU"});setisValidCode(true); }
             if(xhr.status==500) {toaster.show( {icon:"person", intent:Intent.DANGER,timeout:2000,message:"Identifiant ou mot de passe incorrect"}); }
            // setUserPassword({})
            
            }
           
        }
  return //setisOpenLogin(false)
}
  return (
    <div>
      
      <Button style={{width:300}}onClick={handleClickOpen} intent={Intent.PRIMARY}>
      <Tooltip title="Ajouter">
        <IconButton aria-label="Ajouter" onClick={handleClickOpen}>
          <AddIcon />
        </IconButton>
      </Tooltip>
        Ajouter un enseignant</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Ajouter un enseignant</DialogTitle>
        <DialogContent>
          <DialogContentText>Ajouter votre enseignant en ajoutant son code.</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Code donné par l'enseignant"
            type="number"
            fullWidth
            value={user.firstName}
            onChange={handleChange('firstName')}
          />
          {/*<TextField
            margin="dense"
            label="Last Name"
            type="text"
            fullWidth
            value={user.lastName}
            onChange={handleChange('lastName')}
          />
          <TextField
            margin="dense"
            label="Age"
            type="number"
            fullWidth
            value={user.age}
            onChange={handleChange('age')}
          />
          <TextField
            margin="dense"
            label="Visits"
            type="number"
            fullWidth
            value={user.visits}
            onChange={handleChange('visits')}
          />
          <TextField
            margin="dense"
            label="Status"
            type="text"
            fullWidth
            value={user.status}
            onChange={handleChange('status')}
          />
          <TextField
            margin="dense"
            label="Profile Progress"
            type="number"
            fullWidth
            value={user.progress}
            onChange={handleChange('progress')}
          />*/}
        </DialogContent>
        <DialogActions>
          <Tooltip title="Si vous avez plusieurs codes à saisir">
            <Switch
              checked={switchState.addMultiple}
              onChange={handleSwitchChange('addMultiple')}
              value="addMultiple"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          </Tooltip>
          <Button onClick={handleClose} intent={Intent.DANGER}>
            Annuler
          </Button>
          <Button onClick={handleAdd} intent={Intent.PRIMARY} disabled={!isValidCode}>
            Ajouter
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

AddUserDialog.propTypes = {
  addUserHandler: PropTypes.func.isRequired,
  userid: PropTypes.string
}

export default AddUserDialog
